// web/src/lib/from-email-addresses.ts
//
// T21 — Admin CRUD for "from" email addresses (`/api/admin/from-email-addresses`).
// A null/empty emailAddress means "sender's own address" (e.g. REQEMPLOYEE).
import { get, post, apiFetch } from "./api";

export interface FromEmailAddress {
  fromEmailAddressId: number;
  code: string;
  description: string;
  emailAddress: string | null;
  display: boolean;
}

export type FromEmailAddressWrite = Omit<FromEmailAddress, "fromEmailAddressId">;

export const fromEmailAddressesApi = {
  list: (): Promise<FromEmailAddress[]> =>
    get<FromEmailAddress[]>("/api/admin/from-email-addresses"),
  create: (body: FromEmailAddressWrite): Promise<FromEmailAddress> =>
    post<FromEmailAddress>("/api/admin/from-email-addresses", body),
  update: (id: number, body: FromEmailAddressWrite): Promise<void> =>
    apiFetch<void>(`/api/admin/from-email-addresses/${id}`, {
      method: "PUT",
      body: JSON.stringify(body),
    }),
  remove: (id: number): Promise<void> =>
    apiFetch<void>(`/api/admin/from-email-addresses/${id}`, { method: "DELETE" }),
};
